import { Box, Text } from '@chakra-ui/react';

const STATUS_CONFIG = {
  offer_sent: {
    heading: 'Your new plan is ready to review',
    subheading: null,
  },
  pending_signature: {
    heading: "It's time to sign your contract",
    subheading:
      'A member of our team will be in touch with your contract. Once signed, you will be able to confirm and pay here to complete your upgrade.',
  },
  signature_received: {
    heading: 'Complete payment to activate your plan',
    subheading:
      "We've received your signed contract. Payment is now required to activate your custom plan. Once processed, your plan will go live automatically.",
  },
  accepted: {
    heading: 'Complete payment to activate your plan',
    subheading:
      'Payment is now required to activate your custom plan. Once processed, your plan will go live automatically.',
  },
};

const DEFAULT_CONFIG = {
  heading: 'Your custom plan request',
  subheading: null,
};

const CustomPlanOfferHeading = ({ status }) => {
  const config = STATUS_CONFIG[status] || DEFAULT_CONFIG;

  return (
    <Box>
      <Text textStyle="heading3" mt={4}>
        {config.heading}
      </Text>
      {config.subheading && (
        <Text textStyle="bodySmall" color="gray.600" mt={2}>
          {config.subheading}
        </Text>
      )}
    </Box>
  );
};

export default CustomPlanOfferHeading;
